//#region Importcaret
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { gatewayApi } from '../../../../services/apis';
import { FlightCancelRules } from '../../..';
import { MobilePriceDetails } from '../../../../component';
import { connect } from 'react-redux';
import {
  returnFlightDate,
  returnFormatTime,
  getDayDiff,
  returnMonthDay,
  createDetailPriceListFlight,
  returnAirlineLogos,
} from '../../../../utils/utility/booking';
import { dateDiff, fullMonths } from '../../../../utils/consts/months';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  ClockFillIcon,
  CircleIcon,
  BaggageIcon,
  AirplaneIcon,
  FlightTicketIcon,
  CabinTypeIcon,
} from '~svg';
import './mobileFlightDetails.scss';

//#endregions
class MobileFlightDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelRules: [],
      selectedIndex: 0,
      showDetailFlag: [],
      priceShowStatus: true,
      ruleShowStatus: true,
      priceList: [],
    };
    this.fetchCancelData(this.props.flight);
  }
  //#region Component life cycle
  componentDidMount() {
    let { flight } = this.props;
    this.setPriceList(flight, 0);
    let allDetailFlag = new Array(flight.Itineraries.length).fill(true);
    this.setState({ showDetailFlag: allDetailFlag });
    this.handleScroll();
  }
  componentWillUnmount() {
    this.removeScroll();
  }
  //#endregion
  //#region  Fetch APIs
  fetchCancelData = (item) => {
    let { cancelRules } = this.state;
    let promise_arr = [];
    let itineraries = item.Itineraries
      ? item.Itineraries
      : item.flights.itineraries;
    //create object to call canceling rules api
    itineraries.map((itinerary, index) => {
      let obj = {
        providerType: item.ProviderType,
        sequenceNumber: item.SequenceNumber,
        combinationId: item.CombinationId,
        gatewayData: item.GatewayData,
        itineraryFlights: this.createItinerary(itinerary),
      };

      let res = gatewayApi.cancelRules({ data: obj });
      promise_arr.push(res);
      if (promise_arr.length)
        Promise.all(promise_arr)
          .then((res) => {
            if (res.length) {
              res.forEach((result) => {
                let rules = {
                  cancelingRuleText:
                    result.length && result[0].cancelingRuleText !== ''
                      ? result[0].cancelingRuleText
                      : '',
                  miniRulesPriceText:
                    result.length &&
                    result[0].cancelingRuleText === '' &&
                    result[0].cancelingRule.length === 0 &&
                    result[0].flightRule &&
                    result[0].flightRule.miniRulesPriceText
                      ? result[0].flightRule.miniRulesPriceText
                      : null,
                  cancelingRule:
                    result[0] && result[0].cancelingRule.length
                      ? result[0].cancelingRule
                      : [],
                  noCancelRules:
                    (result[0] && result[0].cancelingRule.length > 0) ||
                    (result.length && result[0].cancelingRuleText !== '') ||
                    (result &&
                      result[0].flightRule &&
                      result[0].flightRule.miniRulesPriceText)
                      ? null
                      : this.props.intl.formatMessage({
                          id: 'booking.nocancelrules',
                        }),
                };
                cancelRules[index] = rules;

                this.setState({ cancelRules });
              });
              this.setState({ cancelRules });
            }
          })
          .catch((error) => {
            let rules = {
              cancelingRuleText: '',
              cancelingRule: [],
              noCancelRules: this.props.intl.formatMessage({
                id: 'booking.nocancelrules',
              }),
            };
            cancelRules[index] = rules;

            this.setState({ cancelRules });
          });
    });
  };
  //#endregion
  //#region  handleControls

  handleScroll = () => {
    document.addEventListener('load', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  removeScroll = () => {
    window.removeEventListener('load', this.handleScroll());
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  //#endregion
  //#region  functions

  setPriceList = (item, index) => {
    let { parsedQueryStr } = this.props;
    let { priceList } = this.state;
    let { name } = this.props.language;
    priceList = createDetailPriceListFlight(item, parsedQueryStr, name);
    //for internal flight we have price of each flight so we add flight name to list

    this.setState({ priceList, currentIndex: index });
  };
  //create Itenerirs object for pass the canceling rules api
  createItinerary = (item) => {
    let itinerary = [];
    let flights = item.Flights ? item.Flights : item.flights;
    flights.forEach((element) => {
      let obj = {};
      obj.gatewayCode = item.Gateway.Code;
      obj.airlineCode = element.OperatingAirline.Code;
      obj.resBookDesigCode = element.ResBookDesigCode;
      obj.gatewayData = element.GatewayData;
      itinerary.push(obj);
    });
    return itinerary;
  };
  changeCancelShowStatus = () => {
    let { ruleShowStatus } = this.state;
    this.setState({ ruleShowStatus: !ruleShowStatus });
  };
  changePriceShowStatus = () => {
    let { priceShowStatus } = this.state;
    this.setState({ priceShowStatus: !priceShowStatus });
  };
  //calculate baggage and convert it to kg
  calculateBaggage = (baggage, resBookDesigCabinName) => {
    const baggageobj = baggage.filter(
      (t) => t.Type === 'ADT' || t.type === 'ADT',
    )[0];
    let quantity = 0;
    if (baggageobj)
      quantity =
        baggageobj.Unit.toLowerCase() === 'kg'
          ? baggageobj.Quantity
          : resBookDesigCabinName['en'].toLowerCase().includes('economy')
          ? 23 * baggageobj.Quantity
          : 32 * baggageobj.Quantity;
    return quantity;
  };
  //flag to showor hide details of each flight
  setFlagToshowDetail = (index, event) => {
    let { showDetailFlag } = this.state;
    showDetailFlag[index] = !showDetailFlag[index];
    this.setState({ selectedIndex: index, showDetailFlag });
  };
  //#endregion
  //#region Render Designs

  renderAirplaneIcon(flight) {
    let { name, direction } = this.props.language;
    let allAirlines = [
      ...new Set(flight.map((t) => [t.OperatingAirline])),
    ].reduce((a, b) => {
      return a.concat(b);
    });
    let operatingAirline = [
      ...new Map(allAirlines.map((item) => [item.Code, item])).values(),
    ];
    if (flight && flight.length > 0 && operatingAirline.length) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center px-1">
          <div className="d-flex flex-row align-items-center justify-content-center w-100  position-relative">
            {operatingAirline.map((item, index) => {
              let position = -30 * index;
              return (
                <img
                  key={`img-${index}`}
                  style={{
                    width: 34,
                    hight: 34,
                    zIndex: operatingAirline.length - index,
                    marginRight:
                      direction === 'ltr'
                        ? operatingAirline.length === 1 || index === 0
                          ? '0px'
                          : `${position}px`
                        : '0px',
                    marginLeft:
                      direction === 'rtl'
                        ? operatingAirline.length === 1 || index === 0
                          ? '0px'
                          : `${position}px`
                        : '0px',
                  }}
                  title={item.Name[name]}
                  className={`d-flex justify-content-center p-1 rounded-circle bg-white border border-1 ${
                    index === 0 ? '' : 'position-absolute'
                  }
                   
                   `}
                  src={returnAirlineLogos(item.Code)}
                  alt="operating Airline"
                />
              );
            })}
          </div>

          {operatingAirline.length === 1 ? (
            <div className="text-primary d-flex justify-content-center w-100 align-items-start font-xsmall text-center font-weight-bold p-1">
              {operatingAirline[0].Name[name]}
            </div>
          ) : (
            <div className=" text-primary d-flex justify-content-center p-1 w-100 align-items-start font-xsmall text-center font-weight-bold position-relative">
              {this.props.intl.formatMessage({
                id: 'booking.multiairline',
              })}
            </div>
          )}
        </div>
      );
    }
  }
  renderFlightDetailInfo = (iconName, title, value, color = null) => {
    return (
      <>
        <div className="d-flex align-items-center justify-content-start  w-100  ">
          <div className={` col-1 px-0 text-center`}>{iconName}</div>
          <span className="d-flex font-smaller text-dark  px-1">
            <FormattedMessage id={`booking.${title}`} /> {' : '}
          </span>
          <span className={`d-flex ${color ? color : 'text-secondary'} px-0`}>
            {value || '--'}
          </span>
        </div>
      </>
    );
  };
  render() {
    let { flight, user } = this.props,
      { name, direction } = this.props.language,
      {
        cancelRules,
        showDetailFlag,
        priceShowStatus,
        priceList,
        ruleShowStatus,
      } = this.state,
      itineraries = flight.Itineraries,
      profileId = localStorage.getItem('profile'),
      isAgency =
        user?.userInfo?.profile && profileId && profileId !== 'individual';

    return (
      <React.Fragment>
        <div
          className="d-flex w-100 flex-column"
          style={{ height: '85vh', minHeight: '85vh', overflowY: 'scroll' }}
        >
          {itineraries.map((itenery, iteneryIndex) => {
            let flights = itenery.Flights;
            const departure = itenery.Flights[0].DepartureAirport,
              arrival =
                itenery.Flights[itenery.Flights.length - 1].ArrivalAirport,
              dayDiff = getDayDiff(
                itenery.Flights[0].DepartureDateTime,
                itenery.Flights[itenery.Flights.length - 1].ArrivalDateTime,
              ),
              cityName = departure.CityName,
              arrivalCityName = arrival.CityName;
            let dateArray =
              itenery.Flights[0].DepartureDateTime.split('T')[0].split('-');

            return (
              <div
                key={`allFlight-${iteneryIndex}`}
                className="bg-third-light pb-2"
              >
                <div className="d-flex align-items-center justify-content-between font-small px-2 py-1 text-truncate font-weight-bold">
                  <div className="d-flex justify-content-start align-items-center">
                    <div className="d-flex  flex-column justify-content-center align-items-center ">
                      {this.renderAirplaneIcon(flights)}
                    </div>
                    <div className="d-flex  align-items-center flex-column px-3 ">
                      <div
                        className="w-100 justify-content-center d-flex align-items-center pb-1"
                        onClick={() => {
                          this.setFlagToshowDetail(iteneryIndex);
                        }}
                      >
                        <div className="align-items-center text-secondary ">
                          <span className="text-truncate">
                            {cityName[name].length > 10
                              ? `${cityName[name].substring(0, 10)}...`
                              : cityName[name]}
                          </span>

                          <span className="px-1">
                            {itenery.Flights[0].DepartureDateTime.split(
                              'T',
                            )[1].substring(0, 5)}
                          </span>
                        </div>

                        <div>
                          <span className="text-truncate text-secondary">
                            {arrivalCityName[name].length > 10
                              ? `${arrivalCityName[name].substring(0, 10)}...`
                              : arrivalCityName[name]}
                          </span>
                          <span className="px-1 text-secondary">
                            {itenery.Flights[
                              itenery.Flights.length - 1
                            ].ArrivalDateTime.split('T')[1].substring(0, 5)}
                          </span>
                        </div>
                        <span className="text-primary-light ">
                          {dayDiff !== 0
                            ? dayDiff > 0
                              ? `+${dayDiff}`
                              : dayDiff
                            : ''}
                        </span>
                      </div>

                      <div className="w-100 d-flex justify-content-start text-third font-smaller pb-1">
                        {`${returnFlightDate(
                          itenery.Flights[0].DepartureDateTime,
                          name,
                          true,
                        )}
                `}
                        {/* -   ${[
                      itenery.ElapsedTime.slice(0, 2),
                      ":",
                      itenery.ElapsedTime.slice(2),
                    ].join("")} */}
                      </div>
                      {direction === 'rtl' ? (
                        <div className="w-100 d-flex justify-content-start text-third font-smaller">
                          {`${dateArray[2]} ${
                            fullMonths['ltr']['fa'][dateArray[1] - 1]
                          } ${dateArray[0]} `}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div
                    style={{
                      transform: showDetailFlag[iteneryIndex]
                        ? 'rotate(-180deg)'
                        : 'rotate(0)',
                    }}
                    className="d-flex d-flex justify-content-end"
                    onClick={(event) => {
                      event.stopPropagation();
                      this.setFlagToshowDetail(iteneryIndex);
                    }}
                  >
                    <ChevronDownIcon size={16} color="#3d4a8f" />
                  </div>
                </div>
                <div
                  className={`d-flex  m-2 bg-white mobile-rounded text-dark card flex-column font-weight-bold `}
                >
                  {flights.map((flightItem, index) => {
                    let departDate = flightItem.DepartureDateTime,
                      arrivalDate = flightItem.ArrivalDateTime,
                      departureAirportName = flightItem.DepartureAirport.Name,
                      arrivalAirportName = flightItem.ArrivalAirport.Name,
                      departureAirportCode = flightItem.DepartureAirport.Code,
                      arrivalAirportCode = flightItem.ArrivalAirport.Code,
                      departDateArray = departDate.split('T')[0].split('-'),
                      arriveDateArray = arrivalDate.split('T')[0].split('-');

                    return (
                      <React.Fragment
                        id={`detailFlight-${index}`}
                        key={`detailFlight-${index}`}
                      >
                        {!!showDetailFlag[iteneryIndex] && (
                          <div className="font-small d-flex text-start text-third  flex-column">
                            <div className="font-small d-flex text-start text-third  justify-content-center  my-2  flex-column align-items-start ">
                              <div className="d-flex justify-content-between w-100 align-items-center">
                                <div className="col-5 d-flex text-dark text-truncate font-smaller px-0 justify-content-start align-items-center ">
                                  <span className="px-3">{`${departureAirportCode} - ${departureAirportName[name]}`}</span>
                                </div>
                                <div className="col-2 d-flex flex-column text-nowrap px-0 align-items-center text-dark font-smaller justify-content-start ">
                                  <img
                                    style={{ width: 30 }}
                                    className={`d-flex justify-content-center px-1 rounded-circle`}
                                    src={returnAirlineLogos(
                                      flightItem.OperatingAirline.Code,
                                    )}
                                    alt="airLine logo"
                                  />
                                  {flightItem.OperatingAirline.Name[name]}
                                </div>

                                <div className="d-flex col-5 align-items-center justify-content-end  text-dark font-smaller ">
                                  <FormattedMessage
                                    id="booking.flightno"
                                    defaultMessage="booking.flightno"
                                  />
                                  {` : `}
                                  <span className="text-primary-light font-msmall font-weight-bold px-1">
                                    {flightItem.FlightNumber}
                                  </span>
                                </div>
                              </div>
                              <div className="d-flex p-0 align-items-around justify-content-center w-100 my-3 ">
                                <div className="d-flex flex-column py-0 col-5 position-relative flex-fill justify-content-between text-dark  font-smaller align-items-start">
                                  <div className="w-100 d-flex flex-column justify-content-start align-items-center text-secondary">
                                    <div className="d-flex text-primary-light font-normal justify-content-start ">
                                      {`${departDate
                                        .split('T')[1]
                                        .substring(0, 5)}`}
                                    </div>
                                    <span className="px-1 text-wrap text-sm-nowrap">
                                      {flightItem.DepartureDateTime
                                        ? returnMonthDay(
                                            flightItem.DepartureDateTime,
                                            name,
                                          )
                                        : '--'}
                                      {direction === 'rtl'
                                        ? `- ${departDateArray[2]} ${
                                            fullMonths['ltr']['fa'][
                                              departDateArray[1] - 1
                                            ]
                                          } 
                                    `
                                        : null}
                                    </span>
                                  </div>

                                  <div className="d-flex align-items-center justify-content-center w-100 font-smaller text-dark px-1">
                                    <FormattedMessage
                                      id="booking.duration"
                                      defaultMessage="booking.duration"
                                    />
                                    {` : `}
                                    <span className="text-secondary font-weight-bold px-1 font-msmall ">
                                      {flightItem.FlightDuration &&
                                      flightItem.FlightDuration !== '0'
                                        ? returnFormatTime(
                                            flightItem.FlightDuration,
                                            direction,
                                            this.props.intl,
                                            true,
                                          )
                                        : '--'}
                                    </span>
                                  </div>
                                  <div className="w-100 d-flex flex-column justify-content-start align-items-center text-secondary">
                                    <div className="d-flex text-primary-light font-normal justify-content-start">
                                      {`${arrivalDate
                                        .split('T')[1]
                                        .substring(0, 5)}`}
                                    </div>
                                    <span className="px-1 text-wrap text-sm-nowrap">
                                      {returnMonthDay(arrivalDate, name)}
                                      {direction === 'rtl'
                                        ? `- ${arriveDateArray[2]} ${
                                            fullMonths['ltr']['fa'][
                                              arriveDateArray[1] - 1
                                            ]
                                          } 
                                    `
                                        : null}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className={`d-flex align-items-center justify-content-around text-dark col-7 px-0 flex-column detail-border-${direction}   position-relative`}
                                >
                                  <div
                                    style={{ top: -7 }}
                                    className={`position-absolute detail-top-circle-${direction}`}
                                  >
                                    <CircleIcon size={10} color="#4c54b9" />
                                  </div>
                                  <div
                                    style={{ gap: 15 }}
                                    className="flex-column d-flex w-100 text-third flex-fill  font-smaller px-2 align-items-center justify-content-around "
                                  >
                                    {this.renderFlightDetailInfo(
                                      <CabinTypeIcon
                                        size={12}
                                        color="#3d4a8f"
                                      />,
                                      'cabin',
                                      flightItem.BookingClassAvails &&
                                        flightItem.BookingClassAvails
                                          .ResBookDesigCabinName
                                        ? `${flightItem.BookingClassAvails.ResBookDesigCabinName[name]}(${flightItem.BookingClassAvails.ResBookDesigCode})`
                                        : '--',
                                    )}
                                    {this.renderFlightDetailInfo(
                                      <FlightTicketIcon
                                        size={12}
                                        color="#3d4a8f"
                                      />,
                                      'tickettype',
                                      <FormattedMessage
                                        id={`booking.${
                                          itenery.isCharter
                                            ? 'charter'
                                            : 'systemic'
                                        }`}
                                      />,
                                      itenery.isCharter
                                        ? 'text-danger'
                                        : 'systemType-text',
                                    )}
                                    {this.renderFlightDetailInfo(
                                      <BaggageIcon size={12} color="#3d4a8f" />,
                                      'baggages',
                                      `${this.calculateBaggage(
                                        flightItem.Baggage,
                                        flightItem.BookingClassAvails
                                          .ResBookDesigCabinName,
                                      )} ${this.props.intl.formatMessage({
                                        id: 'booking.kg',
                                      })}`,
                                    )}

                                    {this.renderFlightDetailInfo(
                                      <AirplaneIcon
                                        size={12}
                                        color="#3d4a8f"
                                      />,
                                      'airplanetype',
                                      flightItem.Equipment
                                        ? flightItem.Equipment.Name[name]
                                        : '--',
                                    )}
                                    {this.renderFlightDetailInfo(
                                      //"chair",
                                      <CabinTypeIcon
                                        size={12}
                                        color="#3d4a8f"
                                      />,
                                      'remainseat',
                                      flightItem.BookingClassAvails &&
                                        flightItem.BookingClassAvails
                                          .ResBookDesigQuantity
                                        ? flightItem.BookingClassAvails
                                            .ResBookDesigQuantity
                                        : '--',
                                    )}
                                  </div>

                                  <div
                                    style={{
                                      top: '40%',
                                      transform: 'rotate(90deg)',
                                    }}
                                    className={` position-absolute detail-top-circle-${direction}`}
                                  >
                                    <ClockFillIcon size={12} color="#4c54b9" />
                                  </div>
                                  <div
                                    style={{ bottom: -7 }}
                                    className={` position-absolute detail-top-circle-${direction}`}
                                  >
                                    <CircleIcon size={10} color="#4c54b9" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex w-100 pt-1 pb-2 px-3 mb-1">
                              <div className="d-flex text-dark w-100 text-truncate font-smaller ">
                                {`${arrivalAirportCode} - ${arrivalAirportName[name]}`}
                              </div>
                            </div>
                          </div>
                        )}

                        {!!showDetailFlag[iteneryIndex] &&
                          flights.length > 1 &&
                          index + 1 <= flights.length &&
                          flights[index + 1] && (
                            <div className="col-12 d-flex p-0 m-0 flex-row font-smaller">
                              <div className="d-flex flex-start col-1 p-0">
                                <hr
                                  style={{ border: 'dotted 0.5px #cec0c0' }}
                                  className="col-12 p-0"
                                  size="1"
                                />
                              </div>
                              <div
                                className="d-flex bg-white flex-center align-items-center justify-content-center col-10 p-0 border-third"
                                style={{
                                  borderRadius: 8,
                                  borderWidth: 1,
                                  borderStyle: 'dotted',
                                }}
                              >
                                <div className="d-flex px-2 ">
                                  <span className="font-smaller  text-dark">
                                    <FormattedMessage
                                      id="booking.stopduration"
                                      defaultMessage="booking.stopduration"
                                    />
                                  </span>
                                  <span className="text-primary  font-smaller px-1">
                                    {flights.length > 1 &&
                                      index + 1 <= flights.length &&
                                      flights[index + 1] &&
                                      ` ${returnFormatTime(
                                        dateDiff(
                                          flights[index + 1].DepartureDateTime,
                                          flights[index].ArrivalDateTime,
                                        ),
                                        direction,
                                        this.props.intl,
                                      )}`}
                                  </span>
                                  <span className="text-dark font-smaller  ">
                                    <FormattedMessage
                                      id="booking.in"
                                      defaultMessage="booking.in"
                                    />
                                  </span>
                                  <span className="text-primary px-1 font-smaller ">{`${flightItem.ArrivalAirport.CityName[name]} `}</span>
                                </div>
                              </div>
                              <div className="d-flex p-0 flex-end col-1">
                                <hr
                                  style={{ border: 'dotted 0.5px #cec0c0' }}
                                  className="col-12 p-0"
                                  size="1"
                                />
                              </div>
                            </div>
                          )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            );
          })}

          <div id="accordionPrice" className="px-2  my-2 font-weight-bold">
            <div className="card mobile-rounded p-2">
              <div
                className="card-header border-0 px-0 flex-start d-flex py-1"
                id="PriceHeadingOne"
              >
                <span
                  onClick={() => this.changePriceShowStatus()}
                  className={`mb-0 text-primary  cursor-pointer text-captalize font-weight-bold font-msmall w-100 text-start`}
                >
                  <FormattedMessage id="booking.pricedetail" /> (
                  <FormattedMessage id="booking.toman" />)
                  {priceShowStatus ? (
                    <ChevronUpIcon size={12} color="#3d4a8f" />
                  ) : (
                    <ChevronDownIcon size={12} color="#3d4a8f" />
                  )}
                </span>
              </div>
              {priceShowStatus ? (
                <div className="my-2">
                  <MobilePriceDetails
                    priceList={priceList}
                    parsedQueryStr={this.props.parsedQueryStr}
                    item={flight}
                    intl={this.props.intl}
                    isAgency={isAgency}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div
            id={`accordionRule`}
            className="px-2 font-weight-bold accordionRule"
          >
            <div className="card mobile-rounded p-2">
              <div
                className="card-header border-0 px-0 flex-start d-flex py-1"
                id="headingOne"
              >
                <span
                  onClick={() => this.changeCancelShowStatus()}
                  className={`mb-0 text-primary cursor-pointer text-captalize font-weight-bold font-msmall w-100 text-start`}
                >
                  <FormattedMessage id="booking.cancelingrules" />
                  <span className="px-2">
                    {ruleShowStatus && ruleShowStatus ? (
                      <ChevronUpIcon size={12} color="#3d4a8f" />
                    ) : (
                      <ChevronDownIcon size={12} color="#3d4a8f" />
                    )}
                  </span>
                </span>
              </div>

              {ruleShowStatus ? (
                <div>
                  {itineraries.map((itenery, indx) => {
                    return cancelRules[indx] ? (
                      <div
                        key={`ruleAccordion${indx}`}
                        className="d-flex px-2 w-100 flex-column card my-2 mobileBackground"
                      >
                        <div className="text-secondary text-start bg-transparent font-msmall card-header">
                          {`${
                            itenery.Flights[0].DepartureAirport.CityName[name]
                          } - ${
                            itenery.Flights[itenery.Flights.length - 1]
                              .ArrivalAirport.CityName[name]
                          }`}
                        </div>
                        <div className="card-body p-0">
                          <FlightCancelRules
                            cancelingRuleText={
                              cancelRules[indx].cancelingRuleText
                            }
                            isMobile={true}
                            cancelingRule={cancelRules[indx].cancelingRule}
                            noCancelRules={cancelRules[indx].noCancelRules}
                            miniRulesPriceText={
                              cancelRules[indx].miniRulesPriceText
                            }
                            darkMode={false}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center">
                        <img
                          style={{ width: 35 }}
                          src={require('../../../../content/images/icon/spinner.gif')}
                          alt="spinner"
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <div
          style={{ minHeight: '5vh', bottom: 0 }}
          className="d-flex w-100 justify-content-between align-items-center p-3 bg-third-light  cursor-pointer position-fixed"
        >
          <div
            className={`bg-primary-light text-white default-border-radius col-5  font-small p-2  tex-captalize d-flex align-items-center justify-content-center `}
            onClick={() => this.props.backButton()}
          >
            <FormattedMessage id="booking.back" defaultMessage="booking.back" />
          </div>
          <div
            className={`btn-secondary col-5 font-small p-2  tex-captalize d-flex align-items-center justify-content-center default-border-radius  text-white`}
            onClick={() => this.props.selectFlight(flight)}
          >
            <FormattedMessage
              id="booking.selectflight"
              defaultMessage="booking.selectflight"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  //#endregion
}
//#region Redux
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
//#endregion

export default injectIntl(connect(mapStateToProps)(MobileFlightDetails));
